class HeaderPartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            pageDots: false,
            prevNextButtons: true,
            wrapAround: true,
            groupCells: true,
            cellSelector: '.homepage-header__partner-slide',
            cellAlign: 'left',
            imagesLoaded: true
        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default HeaderPartnersSlider;
